import { all } from "redux-saga/effects";
import { bienLaiPagingSaga } from "./bienLaiPagingSaga";
import { bienLaiViewChiTietSaga } from "./bienLaiViewChiTietSaga";
import { bienLaiViewSaga } from "./bienLaiViewSaga";
import { bienLaiViewTheoLopChiTietSaga } from "./bienLaiViewTheoLopChiTietSaga";
import { bienLaiViewTheoLopSaga } from "./bienLaiViewTheoLopSaga";
import { bienLaiViewTuyenSinhSaga } from "./bienLaiViewTuyenSinhSaga";

export default function* bienLaiSagaWrapper() {
  yield all([
    bienLaiViewSaga(),
    bienLaiViewTuyenSinhSaga(),
    bienLaiViewChiTietSaga(),
    bienLaiPagingSaga(),
    bienLaiViewTheoLopSaga(),
    bienLaiViewTheoLopChiTietSaga(),
  ]);
}
